/* Product information follows the existing variant picker; it never edits the purchase form. */
(() => {
  if (customElements.get('custom-print-details')) return;
  class CustomPrintDetails extends HTMLElement {
    connectedCallback() {
      this.panels = [...this.querySelectorAll('[data-details-variants]')];
      this.fallback = this.querySelector('[data-details-fallback]');
      this.selection = this.querySelector('[data-details-selection]');
      const configurator = document.querySelector('custom-print-configurator');
      this.form = document.getElementById(configurator?.dataset.formId);
      this.mainSection = configurator?.dataset.section;
      this.select(this.form?.elements.namedItem('id')?.value || this.dataset.variantId);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe?.();
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (String(event.data?.sectionId) !== String(this.mainSection)) return;
          // Read the current selection so a late response cannot restore old details.
          this.select(this.form?.elements.namedItem('id')?.value || event.data?.variant?.id);
        });
      }
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    select(id) {
      const matches = this.panels.filter(panel => panel.dataset.detailsVariants.split(',').includes(String(id)));
      const selected = matches.length === 1 ? matches[0] : null;
      for (const panel of this.panels) panel.hidden = panel !== selected;
      this.fallback.hidden = Boolean(selected);
      this.selection.textContent = selected?.dataset.detailsHeading || '';
      this.selection.hidden = !selected;
      this.dataset.variantId = String(id || '');
    }
  }
  customElements.define('custom-print-details', CustomPrintDetails);
})();
